var themeContract = {
  argos: {
    successAlert: {
      color: 'base',
      background: 'lighter'
    },
    errorAlert: {
      color: 'base'
    },
    infoAlert: {
      color: 'base',
      background: 'lighter'
    }
  },
  habitat: {
    successAlert: {
      color: 'darker',
      background: 'lighter'
    },
    errorAlert: {
      color: 'darker'
    },
    infoAlert: {
      color: 'darker',
      background: 'lighter'
    }
  },
  tu: {
    successAlert: {
      color: 'text',
      background: 'light'
    },
    errorAlert: {
      color: 'darker'
    },
    infoAlert: {
      color: 'text',
      background: 'light'
    }
  },
  nectar: {
    successAlert: {
      color: 'text',
      background: 'light'
    },
    errorAlert: {
      color: 'darker'
    },
    infoAlert: {
      color: 'text',
      background: 'light'
    }
  },
  sainsburys: {
    successAlert: {
      color: 'text',
      background: 'light'
    },
    errorAlert: {
      color: 'darker'
    },
    infoAlert: {
      color: 'text',
      background: 'light'
    }
  }
};
export { themeContract };